import { lazy } from 'react';

import type { RouteObject } from 'react-router-dom';

/**
 * Rotas do módulo de pedidos de ajuda, em dois grupos com montagem diferente.
 *
 * `requests` ("Meus pedidos SOS") e `requests/public` (a fila de pedidos
 * públicos, só para quem atende por um QG — T23 da planilha de 2026-10-31)
 * ficam **dentro** do `AppLayout`: são destinos da barra e do menu, e esconder
 * a barra deixaria a pessoa sem volta. `help-request`
 * (o fluxo SOS) fica **fora**: é fluxo de tarefa, e um toque acidental numa aba
 * no meio do formulário descartaria um pedido de socorro — a mesma decisão que
 * vale para criar instituição (`config/navigation.ts`).
 *
 * ⚠️ **As duas deixaram de ser iguais quanto a sessão.** A aba Pedidos continua
 * só para quem tem conta — ela **lê** dado de vítima, e DV-03 não mudou. O fluxo
 * SOS passou a aceitar convidado (DV-24): quem chega sem sessão informa um
 * e-mail e o envio abre uma conta anônima que vira a autora do pedido. Quem
 * monta a guarda é `src/routes/index.tsx`; aqui as duas listas continuam
 * separadas pelo motivo de sempre, que é a barra inferior.
 */

const HelpRequestPage = lazy(() => import('./routes/HelpRequest.page'));
const RequestsPage = lazy(() => import('./routes/Requests.page'));
const PublicRequestsPage = lazy(() => import('./routes/PublicRequests.page'));

/** Destinos da barra e do menu — dentro do `AppLayout`. */
export const helpRequestRoutes: RouteObject[] = [
  { path: 'requests', element: <RequestsPage /> },
  { path: 'requests/public', element: <PublicRequestsPage /> },
];

/** Fluxo de tarefa — fora do `AppLayout`, sem a barra. */
export const helpRequestProtectedRoutes: RouteObject[] = [
  { path: 'help-request', element: <HelpRequestPage /> },
];
